import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1195. 支払タスクプロジェクト按分費用削除
 * [DELETE] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/payment_tasks/:task_id/order_allocated_expenses/:id
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  task_id: number;
  id: number;
};

const destroyOrderAllocatedExpense = (props: Props): Promise<any> => {
  return axios.delete(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/payment_tasks/${props.task_id}/order_allocated_expenses/${props.id}`
  );
};

export const useDestroyOrderAllocatedExpense = () => {
  return useMutation({
    mutationFn: destroyOrderAllocatedExpense,
  });
};
